// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pqMfuMS2jIUqMezVCDr8{padding:12px 24px}`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/ui/CampaignMessages/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA","sourcesContent":[".wrapAddBtn {\n  padding: 12px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapAddBtn": `pqMfuMS2jIUqMezVCDr8`
};
export default ___CSS_LOADER_EXPORT___;
